import { LOCIZE_ERRORS_TRANSLATION_KEYS } from 'app-constants';
import isEmpty from 'lodash/isEmpty';
import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';

export const parseGqlValidationError = (error: unknown) => {
  // @ts-expect-error err has validation
  const errors = error.reduce<Record<string, string>>(
    // @ts-expect-error err has validation
    (acc, err) => {
      for (const key in err.validation) {
        //acc[key] = err.validation[key].join(', ').replace('validation::', '');
        acc[key] = LOCIZE_ERRORS_TRANSLATION_KEYS.isInvalidFormat;
      }

      return acc;
    },
    {},
  );

  if (isEmpty(errors)) {
    return null;
  }
  return errors;
};

export const processGqlFormValidationErrors = <
  TFieldValues extends FieldValues,
>({
  error,
  setFormError,
}: {
  error: unknown;
  setFormError: UseFormSetError<TFieldValues>;
}) => {
  // @ts-expect-error error has graphQLErrors
  if (!Array.isArray(error?.graphQLErrors)) {
    return;
  }

  // @ts-expect-error error has graphQLErrors
  const errors = parseGqlValidationError(error?.graphQLErrors);

  if (!errors) {
    return;
  }

  const errorsEntries = Object.entries(errors);
  for (const [key, errorMessage] of errorsEntries) {
    setFormError(key as Path<TFieldValues>, {
      // @ts-expect-error err has validation
      message: errorMessage,
    });
  }
};
